//@ts-nocheck
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** About_me */
export interface AboutMe {
  /** Username */
  username?: string
}

/** CLV_customers */
export interface CLVCustomers {
  /** Name */
  name?: string
}

/** CLV_job_categories */
export interface CLVJobCategories {
  /** Value */
  value?: string
  /** Label */
  label?: string
}

/** CLV_list */
export interface CLVList {
  /** Customer Name */
  customer_name: string
  /** Vip */
  vip: string
  /** Job Category */
  job_category: string
  /** Length Type */
  length_type: string
  /** Length */
  length: number
  /** Length Average */
  length_average: number
  /** Recency Type */
  recency_type: string
  /** Recency */
  recency: number
  /** Recency Average */
  recency_average: number
  /** Frequency Type */
  frequency_type: string
  /** Frequency */
  frequency: number
  /** Frequency Average */
  frequency_average: number
  /** Monetary Type */
  monetary_type: string
  /** Monetary */
  monetary: number
  /** Monetary Average */
  monetary_average: number
  /** Monetary Vip Type */
  monetary_vip_type: string
  /** Profit Type */
  profit_type: string
  /** Profit */
  profit: number
  /** Profit Average */
  profit_average: number
  /** Profit Vip Type */
  profit_vip_type: string
  /** Group Type Vip */
  group_type_vip: string
  /** Customer Status */
  customer_status: string
  /** Job Category Id */
  job_category_Id?: string
}

/**
 * CLV_sort_enum
 * An enumeration.
 */
export enum CLVSortEnum {
  CustomerNameAsc = 'customer_name_asc',
  CustomerNameDesc = 'customer_name_desc',
  MonetaryAsc = 'monetary_asc',
  MonetaryDesc = 'monetary_desc',
  ProfitAsc = 'profit_asc',
  ProfitDesc = 'profit_desc',
  RecencyAsc = 'recency_asc',
  RecencyDesc = 'recency_desc',
  LengthAsc = 'length_asc',
  LengthDesc = 'length_desc',
  FrequencyAsc = 'frequency_asc',
  FrequencyDesc = 'frequency_desc',
}

/** Customer_details */
export interface CustomerDetails {
  /** Subsidiary */
  subsidiary?: string
  /** Subsidiary Name */
  subsidiary_name?: string
  /** Account Contact */
  account_contact?: string
  /** Type Id */
  type_id?: string
  /** Type Id Name */
  type_id_name?: string
  /** Tonage */
  tonage?: number
  /** Extended Amount */
  extended_amount?: number
  /** Profit */
  profit?: number
  /** Invoice Count */
  invoice_count?: number
  /** Last Happy Call */
  last_happy_call?: string
  /** Max Purchase */
  max_purchase?: string
  /** Max Purchase Id */
  max_purchase_id?: string
  /** Url */
  url?: string
}

/**
 * Customer_details_sort_enum
 * An enumeration.
 */
export enum CustomerDetailsSortEnum {
  TonageAsc = 'tonage_asc',
  TonageDesc = 'tonage_desc',
  ExtendedAmountAsc = 'extended_amount_asc',
  ExtendedAmountDesc = 'extended_amount_desc',
  ProfitAsc = 'profit_asc',
  ProfitDesc = 'profit_desc',
  InvoiceCountAsc = 'invoice_count_asc',
  InvoiceCountDesc = 'invoice_count_desc',
}

/**
 * Customer_sort_enum
 * An enumeration.
 */
export enum CustomerSortEnum {
  TonajAsc = 'tonaj_asc',
  TonajDesc = 'tonaj_desc',
  ProfitAsc = 'profit_asc',
  ProfitDesc = 'profit_desc',
  AmountAsc = 'amount_asc',
  AmountDesc = 'amount_desc',
  InvoiceCountAsc = 'invoice_count_asc',
  InvoiceCountDesc = 'invoice_count_desc',
  LastInvoiceAsc = 'last_invoice_asc',
  LastInvoiceDesc = 'last_invoice_desc',
  ProductTypesPercentAsc = 'product_types_percent_asc',
  ProductTypesPercentDesc = 'product_types_percent_desc',
}

/** Etl_refresh */
export interface EtlRefresh {
  /** Status */
  status?: number
}

/**
 * Finantial_status_enum
 * An enumeration.
 */
export enum FinantialStatusEnum {
  Creditor = 'Creditor',
  Debtor = 'Debtor',
  Cleared = 'Cleared',
  None = 'none',
}

/** Funnel_list */
export interface FunnelList {
  /** Pageviews */
  Pageviews: number
  /** Uniquepageviews */
  UniquePageviews: number
  /** Users */
  users: number
  /** Newusers */
  NewUsers: number
  /** Cnt Phonenumber */
  Cnt_PhoneNumber: number
  /** Cnt Opportunity */
  Cnt_opportunity: number
  /** Cnt Quote */
  Cnt_Quote: number
  /** Cnt Invoice */
  cnt_invoice: number
  /** Cnt Completeinvoice */
  Cnt_Completeinvoice: number
  /** Cnt Newsubsidiaryname */
  Cnt_NewSubsidiaryName: number
}

/** Grade_months */
export interface GradeMonths {
  /** Label */
  label?: string
  /** Value */
  value?: number
}

/** Grade_res_model */
export interface GradeResModel {
  /** Name */
  name?: string
  /** Id */
  Id?: string
  /** Creditor Debtor Status */
  creditor_debtor_status?: string
  /** Purchase Count */
  purchase_count?: number
  /** Total Amount */
  total_amount?: number
  /** Quantity */
  quantity?: number
  /** Profit */
  profit?: number
  /** Credit */
  credit?: number
  /** Resource Quality Percent */
  resource_quality_percent?: number
  /** Freight Supplier Percent */
  freight_supplier_percent?: number
  /** Diff Between Pay Agreement And Payment */
  diff_between_pay_agreement_and_payment?: number
  /** Rank */
  rank?: number
}

/**
 * Grade_sort_enum
 * An enumeration.
 */
export enum GradeSortEnum {
  PurchaseCountAsc = 'purchase_count_asc',
  PurchaseCountDesc = 'purchase_count_desc',
  QuantityDesc = 'quantity_desc',
  QuantityAsc = 'quantity_asc',
  TotalAmountAsc = 'total_amount_asc',
  TotalAmountDesc = 'total_amount_desc',
  ProfitDesc = 'profit_desc',
  ProfitAsc = 'profit_asc',
  RankDesc = 'rank_desc',
  RankAsc = 'rank_asc',
  CreditAsc = 'credit_asc',
  CreditDesc = 'credit_desc',
  FreightSupplierPercentDesc = 'freight_supplier_percent_desc',
  FreightSupplierPercentAsc = 'freight_supplier_percent_asc',
  ResourceQualityPercentAsc = 'resource_quality_percent_asc',
  ResourceQualityPercentDesc = 'resource_quality_percent_desc',
}

/** Grade_supplier_product */
export interface GradeSupplierProduct {
  /** Name */
  name?: string
  /** Id */
  Id?: string
  /**
   * First Purchases
   * @format date
   */
  first_purchases?: string
  /** Type Id */
  type_id?: string
  /** Type Id Name */
  type_id_name?: string
  /** Purchase Count */
  purchase_count?: number
  /** Total Amount Meta */
  total_amount_meta?: number
  /** Quantity */
  quantity?: number
}

/** Grade_years */
export interface GradeYears {
  /** Label */
  label?: number
  /** Value */
  value?: number
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[]
}

/**
 * Inventory_sort_enum
 * An enumeration.
 */
export enum InventorySortEnum {
  ProductNumberAsc = 'product_number_asc',
  ProductNumberDesc = 'product_number_desc',
  InWareAsc = 'in_ware_asc',
  InWareDesc = 'in_ware_desc',
  OutWareAsc = 'out_ware_asc',
  OutWareDesc = 'out_ware_desc',
  InventoryAsc = 'inventory_asc',
  InventoryDesc = 'inventory_desc',
}

/**
 * Inware_sort_enum
 * An enumeration.
 */
export enum InwareSortEnum {
  ProductNumberAsc = 'product_number_asc',
  ProductNumberDesc = 'product_number_desc',
  InWareAsc = 'in_ware_asc',
  InWareDesc = 'in_ware_desc',
}

/** KPI_final_score */
export interface KPIFinalScore {
  /** Final Score */
  final_score?: number
  /** Date */
  date?: string
}

/** KPI_index */
export interface KPIIndex {
  /** Perspective Code */
  perspective_code?: string
  /** Index Code */
  index_code?: string
  /** Index Name */
  index_name?: string
  /** Expert Amount */
  expert_amount?: number
  /** Expert Index Score */
  expert_index_score?: number
  /** Target */
  target?: number
  /** Score */
  score?: number
}

/** KPI_index_details */
export interface KPIIndexDetails {
  /** Index Name */
  index_name?: string
  /** Count */
  count?: number
  table_data: KPIIndexDetailsRecord
}

/** KPI_index_details_record */
export interface KPIIndexDetailsRecord {
  /** Date */
  date?: string
  /** Title */
  title?: string
  /** Value */
  value?: string
  /** Url */
  url?: string
}

/** KPI_index_monthly */
export interface KPIIndexMonthly {
  /** Date */
  date?: string
  /** Month */
  month?: string
  /** Expert Index Score */
  expert_index_score?: number
}

/** KPI_monthly_chart */
export interface KPIMonthlyChart {
  /** Final Score */
  final_score?: number
  /** Date */
  date?: string
  /** Month */
  month?: string
}

/** KPI_names_list */
export interface KPINamesList {
  /** Full Name */
  full_name?: string
}

/** KPI_perspective */
export interface KPIPerspective {
  /** Perspective Name */
  perspective_name: string
  /** Experted Perspective Score */
  experted_perspective_score: number
}

/** KPI_position_list */
export interface KPIPositionList {
  /** Position Id */
  position_Id?: string
  /** Position Id Name */
  position_Id_name?: string
}

/** KPI_team_progress */
export interface KPITeamProgress {
  /** Progress */
  progress?: number
  /** Team Name */
  team_name?: string
}

/** KPI_teams */
export interface KPITeams {
  /** Team Id */
  team_Id: string
  /** Team Name */
  team_name?: string
  /** Date */
  date?: string
  /** Month */
  month?: string
  /** Score */
  score: number
}

/** KPI_teams_List */
export interface KPITeamsList {
  /** Team Id */
  team_Id?: string
  /** Team Name */
  team_name?: string
}

/** KPI_tops_indices */
export interface KPITopsIndices {
  /** Index Name */
  index_name?: string
  /** Expert Index Score */
  expert_index_score?: number
}

/** KPI_tops_model */
export interface KPITopsModel {
  /** Final Score */
  final_score?: number
  /** Team Name */
  team_name?: string
  /** Domain Name */
  domain_name?: string
  /** Position Id Name */
  position_id_name?: string
  /** Full Name */
  full_name?: string
  /** User Id */
  user_Id?: string
}

/** KPI_user */
export interface KPIUser {
  /** Perspective Code */
  perspective_code?: string
  /** Score */
  score?: number
  /** Title */
  title?: string
  /** Index */
  index: KPIIndex[]
}

/** KPI_user_review */
export interface KPIUserReview {
  /** User Kpi Monthly */
  user_KPI_monthly: KPIMonthlyChart[]
  /** User Perspectives */
  user_perspectives: KPIPerspective[]
}

/** Main_table_details */
export interface MainTableDetails {
  /** Product Type Id */
  product_type_Id?: string
  /** Product Type */
  product_type?: string
  /** Percent */
  percent: number
}

/** Main_table_response */
export interface MainTableResponse {
  /** Subsidiary */
  subsidiary: string
  /** Subsidiary Id */
  subsidiary_Id: string
  /** Tonaj */
  tonaj: number
  /** Profit */
  profit: number
  /** Amount */
  amount: number
  /** Invoice Count */
  invoice_count: number
  /**
   * Last Invoice
   * @format date
   */
  last_invoice?: string
  /** Product Types Percent */
  product_types_percent: number
  /** Details */
  details: MainTableDetails[]
  sum: Sum
}

/**
 * Marketing_Budget_sort_enum
 * An enumeration.
 */
export enum MarketingBudgetSortEnum {
  CreditorAmountAsc = 'creditor_amount_asc',
  CreditorAmountDesc = 'creditor_amount_desc',
  DebtorAmountAsc = 'debtor_amount_asc',
  DebtorAmountDesc = 'debtor_amount_desc',
  BalanceAsc = 'balance_asc',
  BalanceDesc = 'balance_desc',
  RemainBudjetAsc = 'remain_budjet_asc',
  RemainBudjetDesc = 'remain_budjet_desc',
}

/** Modal_model */
export interface ModalModel {
  /** Team Id */
  team_id: string
  /** Team Name */
  team_name: string
  /** Year Month */
  year_month: string
  /** Tonage */
  tonage?: number
  /** Extended Amount9 */
  extended_amount9?: number
}

/**
 * Outware_sort_enum
 * An enumeration.
 */
export enum OutwareSortEnum {
  ProductNumberAsc = 'product_number_asc',
  ProductNumberDesc = 'product_number_desc',
  OutWareAsc = 'out_ware_asc',
  OutWareDesc = 'out_ware_desc',
}

/** Page[CLV_list] */
export interface PageCLVList {
  /** Items */
  items: CLVList[]
  /**
   * Total
   * @min 0
   */
  total: number
  /**
   * Page
   * @min 1
   */
  page: number
  /**
   * Size
   * @min 1
   */
  size: number
}

/** Page[Grade_res_model] */
export interface PageGradeResModel {
  /** Items */
  items: GradeResModel[]
  /**
   * Total
   * @min 0
   */
  total: number
  /**
   * Page
   * @min 1
   */
  page: number
  /**
   * Size
   * @min 1
   */
  size: number
}

/** Page[Main_table_response] */
export interface PageMainTableResponse {
  /** Items */
  items: MainTableResponse[]
  /**
   * Total
   * @min 0
   */
  total: number
  /**
   * Page
   * @min 1
   */
  page: number
  /**
   * Size
   * @min 1
   */
  size: number
}

/** Page[inventory] */
export interface PageInventory {
  /** Items */
  items: Inventory[]
  /** Page */
  page?: number
  /** Size */
  size?: number
  /** Total */
  total: number
}

/** Page[inventory_inware] */
export interface PageInventoryInware {
  /** Items */
  items: InventoryInware[]
  /** Page */
  page?: number
  /** Size */
  size?: number
  /** Total */
  total: number
}

/** Page[inventory_outware] */
export interface PageInventoryOutware {
  /** Items */
  items: InventoryOutware[]
  /** Page */
  page?: number
  /** Size */
  size?: number
  /** Total */
  total: number
}

/** Piechart_model */
export interface PiechartModel {
  /** Team Name */
  team_name?: string
  /** Extended Amount9 */
  extended_amount9?: number
  /** Percentage */
  percentage?: number
}

/** Procedure_chart_model */
export interface ProcedureChartModel {
  /** Year Month */
  year_month: string
  /** Extended Amount9 */
  extended_amount9?: number
}

/** Product */
export interface Product {
  /** Name */
  name?: string
  /** Product Number */
  product_number?: string
}

/** Product_Type_res_model */
export interface ProductTypeResModel {
  /** Type Id */
  type_id?: string
  /** Type Id Name */
  type_id_name?: string
}

/** Product_category */
export interface ProductCategory {
  /** Product Category Id */
  product_category_id?: string
  /** Product Category Id Name */
  product_category_id_name?: string
  /** Sales */
  sales?: number
  /** Quantity */
  quantity?: number
  /** Profit */
  profit?: number
  /** Invoice Count */
  invoice_count?: number
  /** Customer Count */
  customer_count?: number
  /** Profit Percent */
  profit_percent?: number
  /** Profit Marigin Percent */
  profit_marigin_percent?: number
}

/** Product_category_pie_chart */
export interface ProductCategoryPieChart {
  /** Product Category Id Name */
  product_category_id_name?: string
  /** Sales */
  sales?: number
  /** Percent Sale */
  percent_sale?: number
  /** Row Num */
  row_num?: number
}

/**
 * Product_category_sort_enum
 * An enumeration.
 */
export enum ProductCategorySortEnum {
  SalesAsc = 'sales_asc',
  QuantityAsc = 'quantity_asc',
  ProfitPercentAsc = 'profit_percent_asc',
  SalesDesc = 'sales_desc',
  QuantityDesc = 'quantity_desc',
  ProfitPercentDesc = 'profit_percent_desc',
}

/**
 * Product_details_sort_enum
 * An enumeration.
 */
export enum ProductDetailsSortEnum {
  QuantityAsc = 'quantity_asc',
  QuantityDesc = 'quantity_desc',
  SalesAsc = 'sales_asc',
  SalesDesc = 'sales_desc',
  ProfitToSellAsc = 'profit_to_sell_asc',
  ProfitToSellDesc = 'profit_to_sell_desc',
  ProfitPercentAsc = 'profit_percent_asc',
  ProfitPercentDesc = 'profit_percent_desc',
  ProfitMariginPercentAsc = 'profit_marigin_percent_asc',
  ProfitMariginPercentDesc = 'profit_marigin_percent_desc',
}

/** Product_type */
export interface ProductType {
  /** Product Category Id Name */
  product_category_id_name?: string
  /** Type Id Name */
  type_id_name?: string
  /** Type Id */
  type_id?: string
  /** Sales */
  sales?: number
  /** Quantity */
  quantity?: number
  /** Profit */
  profit?: number
  /** Invoice Count */
  invoice_count?: number
  /** Customer Count */
  customer_count?: number
  /** Profit Percent */
  profit_percent?: number
  /** Profit Marigin Percent */
  profit_marigin_percent?: number
}

/** Product_type_details */
export interface ProductTypeDetails {
  /** Product Name */
  product_name?: string
  /** Type Id Name */
  type_id_name?: string
  /** Product Id */
  product_id?: string
  /** Brand */
  brand?: string
  /** Model */
  model?: string
  /** Stock */
  stock?: string
  /** Unit Weight */
  unit_weight?: number
  /** Sales */
  sales?: number
  /** Quantity */
  quantity?: number
  /** Profit */
  profit?: number
  /** Profit Percent */
  profit_percent?: number
  /** Profit Marigin Percent */
  profit_marigin_percent?: number
}

/** Product_type_pie_chart */
export interface ProductTypePieChart {
  /** Type Id Name */
  type_id_name?: string
  /** Sales */
  sales?: number
  /** Profit To Sell */
  profit_to_sell?: number
  /** Row Num */
  row_num?: number
}

/**
 * Product_type_sort_enum
 * An enumeration.
 */
export enum ProductTypeSortEnum {
  SalesAsc = 'sales_asc',
  QuantityAsc = 'quantity_asc',
  ProfitPercentAsc = 'profit_percent_asc',
  SalesDesc = 'sales_desc',
  QuantityDesc = 'quantity_desc',
  ProfitPercentDesc = 'profit_percent_desc',
  InvoiceCountAsc = 'invoice_count_asc',
  InvoiceCountDesc = 'invoice_count_desc',
  CustomerCountAsc = 'customer_count_asc',
  CustomerCountDesc = 'customer_count_desc',
}

/** Product_types */
export interface ProductTypes {
  /** Name */
  name?: string
  /** Product Type Id */
  product_type_Id?: string
}

/** Purchase_Purson_model */
export interface PurchasePursonModel {
  /** Expert Name */
  expert_name?: string
  /** Expertid */
  expertId?: string
  /** Purchase Count */
  purchase_count?: number
  /** Quote Count */
  quote_count?: number
  /** Tonage */
  tonage?: number
  /** Profit */
  profit?: number
  /** Purchase Coordinator */
  purchase_coordinator?: number
  /** Total Amount */
  total_amount?: number
  /** Unhappy Customer Count */
  unhappy_customer_count?: number
  /** Uncertain Quote Count */
  uncertain_quote_count?: number
  /** Supplier Count */
  supplier_count?: number
  /** New Sup Count */
  new_sup_count?: number
}

/**
 * Purchase_member_sort_enum
 * An enumeration.
 */
export enum PurchaseMemberSortEnum {
  CoordinatorAsc = 'coordinator_asc',
  CoordinatorDesc = 'coordinator_desc',
  CustomerCountAsc = 'customer_count_asc',
  CustomerCountDesc = 'customer_count_desc',
  ExtendedAmountAsc = 'extended_amount_asc',
  ExtendedAmountDesc = 'extended_amount_desc',
  InvoiceCountAsc = 'invoice_count_asc',
  InvoiceCountDesc = 'invoice_count_desc',
  NewCustomerCountAsc = 'new_customer_count_asc',
  NewCustomerCountDesc = 'new_customer_count_desc',
  ProfitAsc = 'profit_asc',
  ProfitDesc = 'profit_desc',
  QuoteCountAsc = 'quote_count_asc',
  QuoteCountDesc = 'quote_count_desc',
  TonageAsc = 'tonage_asc',
  TonageDesc = 'tonage_desc',
  UncertainQuoteCountAsc = 'uncertain_quote_count_asc',
  UncertainQuoteCountDesc = 'uncertain_quote_count_desc',
  UnhappyCustomerAsc = 'unhappy_customer_asc',
  UnhappyCustomerDesc = 'unhappy_customer_desc',
}

/** Sales_Purson_model */
export interface SalesPursonModel {
  /** Expert Name */
  expert_name?: string
  /** Expertid */
  expertId?: string
  /** Quote Count */
  quote_count?: number
  /** Tonage */
  tonage?: number
  /** Extended Amount */
  extended_amount?: number
  /** Profit */
  profit?: number
  /** Coordinator */
  coordinator?: number
  /** Unhappy Customer */
  unhappy_customer?: number
  /** Uncertain Quote Count */
  uncertain_quote_count?: number
  /** Customer Count */
  customer_count?: number
  /** New Customer Count */
  new_customer_count?: number
  /** Invoice Count */
  invoice_count?: number
}

/**
 * Sales_member_sort_enum
 * An enumeration.
 */
export enum SalesMemberSortEnum {
  CoordinatorAsc = 'coordinator_asc',
  CoordinatorDesc = 'coordinator_desc',
  CustomerCountAsc = 'customer_count_asc',
  CustomerCountDesc = 'customer_count_desc',
  ExtendedAmountAsc = 'extended_amount_asc',
  ExtendedAmountDesc = 'extended_amount_desc',
  InvoiceCountAsc = 'invoice_count_asc',
  InvoiceCountDesc = 'invoice_count_desc',
  NewCustomerCountAsc = 'new_customer_count_asc',
  NewCustomerCountDesc = 'new_customer_count_desc',
  ProfitAsc = 'profit_asc',
  ProfitDesc = 'profit_desc',
  QuoteCountAsc = 'quote_count_asc',
  QuoteCountDesc = 'quote_count_desc',
  TonageAsc = 'tonage_asc',
  TonageDesc = 'tonage_desc',
  UncertainQuoteCountAsc = 'uncertain_quote_count_asc',
  UncertainQuoteCountDesc = 'uncertain_quote_count_desc',
  UnhappyCustomerAsc = 'unhappy_customer_asc',
  UnhappyCustomerDesc = 'unhappy_customer_desc',
}

/** Search_list */
export interface SearchList {
  /** Label */
  label?: string
  /** Value */
  value?: string
}

/** Sum */
export interface Sum {
  /** Sum Profit */
  sum_profit: number
  /** Sum Tonaj */
  sum_tonaj: number
  /** Sum Amount */
  sum_amount: number
  /** Sum Invoice Count */
  sum_invoice_count: number
}

/** Supp_res_model */
export interface SuppResModel {
  /** Name */
  name?: string
  /** Id */
  Id?: string
}

/**
 * Supplier_product_sort_enum
 * An enumeration.
 */
export enum SupplierProductSortEnum {
  QuantityAsc = 'quantity_asc',
  QuantityDesc = 'quantity_desc',
  TotalAmountMetaAsc = 'total_amount_meta_asc',
  TotalAmountMetaDesc = 'total_amount_meta_desc',
  PurchaseCountAsc = 'purchase_count_asc',
  PurchaseCountDesc = 'purchase_count_desc',
}

/**
 * Team_dashboard_sort_enum
 * An enumeration.
 */
export enum TeamDashboardSortEnum {
  TonageAsc = 'tonage_asc',
  TonageDesc = 'tonage_desc',
  ExtendedAmount9Asc = 'extended_amount9_asc',
  ExtendedAmount9Desc = 'extended_amount9_desc',
  CustomerCountAsc = 'customer_count_asc',
  CustomerCountDesc = 'customer_count_desc',
  ProfitAsc = 'profit_asc',
  ProfitDesc = 'profit_desc',
}

/** Team_res_model */
export interface TeamResModel {
  /** Team Id */
  team_Id?: string
  /** Name */
  name?: string
}

/** Times_res_model */
export interface TimesResModel {
  /** Shamsi Month */
  shamsi_month?: string
  /** Year */
  year?: number
  /** Time Key Year */
  time_key_year?: number
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: string[]
  /** Message */
  msg: string
  /** Error Type */
  type: string
}

/** Main_table_model */
export interface AppModelsMarketingBudjetMarketingMainTableModel {
  /** Detail Account */
  detail_account: string
  /** Detail Account Id */
  detail_account_id: string
  /** Creditor Amount */
  creditor_amount?: number
  /** Debtor Amount */
  debtor_amount?: number
  /** Balance */
  balance?: number
  /** Remain Budjet */
  remain_budjet?: number
}

/** Main_table_model */
export interface AppModelsTeamsDashboardMainTableModelMainTableModel {
  /** Team Id */
  team_id: string
  /** Team Name */
  team_name: string
  /** Tonage */
  tonage?: number
  /** Extended Amount9 */
  extended_amount9?: number
  /** Customer Count */
  customer_count?: number
  /** Profit */
  profit?: number
}

/** creditor_res_model */
export interface CreditorResModel {
  /** Id */
  id?: string
  /** Title */
  title?: string
  /**
   * Created On
   * @format date
   */
  created_on?: string
  /** Detail Account */
  detail_account?: string
  /** Creditor Amount */
  creditor_amount?: number
  /** Creditor Detail Account Name */
  creditor_detail_account_name?: string
  /** Creditor Unique Detail Account */
  creditor_unique_detail_account?: string
  /** Fiscal Year Name */
  fiscal_year_name?: string
  /** Url */
  url?: string
}

/** debtor_res_model */
export interface DebtorResModel {
  /** Id */
  id?: string
  /** Title */
  title?: string
  /**
   * Created On
   * @format date
   */
  created_on?: string
  /** Detail Account */
  detail_account?: string
  /** Debtor Amount */
  debtor_amount?: number
  /** Debtor Detail Account Name */
  debtor_detail_account_name?: string
  /** Debtor Unique Detail Account Name */
  debtor_unique_detail_account_name?: string
  /** Fiscal Year Name */
  fiscal_year_name?: string
  /** Url */
  url?: string
}

/** detail_account_res_model */
export interface DetailAccountResModel {
  /** Name */
  name?: string
  /** Id */
  Id?: string
}

/** fiscal_year_res_model */
export interface FiscalYearResModel {
  /** Name */
  name: string
}

/** inventory */
export interface Inventory {
  /** Product Number */
  product_number?: string
  /** Name */
  name?: string
  /** Out Ware */
  out_ware?: number
  /** In Ware */
  in_ware?: number
  /** Inventory */
  inventory?: number
}

/** inventory_inware */
export interface InventoryInware {
  /** Product Number */
  product_number?: string
  /** Name */
  name?: string
  /** In Ware */
  in_ware?: number
  /** Invoice Number */
  invoice_number?: string
}

/** inventory_outware */
export interface InventoryOutware {
  /** Product Number */
  product_number?: string
  /** Name */
  name?: string
  /** Id */
  id?: string
  /** Out Ware */
  out_ware?: number
}

/** remain_budjet_res_model */
export interface RemainBudjetResModel {
  /** Balance */
  balance?: number
  /** Remain Budjet */
  remain_budjet?: number
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    })
  }
}

/**
 * @title FastAPI
 * @version 0.1.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name HomeGet
   * @summary Home
   * @request GET:/
   */
  homeGet = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  kpi = {
    /**
     * No description
     *
     * @tags NAMES_LIST
     * @name NamesListKpiNamesListGet
     * @summary Names List
     * @request GET:/KPI/names-list
     */
    namesListKpiNamesListGet: (
      query?: {
        /** Team Id */
        team_Id?: string
        /** Position Id */
        position_Id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KPINamesList[], HTTPValidationError>({
        path: `/KPI/names-list`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TEAMS_LIST
     * @name TeamsListKpiTeamsListGet
     * @summary Teams List
     * @request GET:/KPI/teams-list
     */
    teamsListKpiTeamsListGet: (
      query?: {
        /** Month */
        month?: string
        /** Year */
        year?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KPITeamsList[], HTTPValidationError>({
        path: `/KPI/teams-list`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags POSITIONS_LIST
     * @name PositionsListKpiPositionsListGet
     * @summary Positions List
     * @request GET:/KPI/positions-list
     */
    positionsListKpiPositionsListGet: (params: RequestParams = {}) =>
      this.request<KPIPositionList[], any>({
        path: `/KPI/positions-list`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NAMES_LIST
     * @name FinalScoreKpiFinalScoreGet
     * @summary Final Score
     * @request GET:/KPI/final-score
     */
    finalScoreKpiFinalScoreGet: (
      query?: {
        /** Month */
        month?: string
        /** Year */
        year?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KPIFinalScore[], HTTPValidationError>({
        path: `/KPI/final-score`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MONTHS
     * @name KpiMonthesKpiMonthsGet
     * @summary Kpi Monthes
     * @request GET:/KPI/months
     */
    kpiMonthesKpiMonthsGet: (params: RequestParams = {}) =>
      this.request<SearchList[], any>({
        path: `/KPI/months`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags YEARS
     * @name KpiYearsKpiYearsGet
     * @summary Kpi Years
     * @request GET:/KPI/years
     */
    kpiYearsKpiYearsGet: (params: RequestParams = {}) =>
      this.request<SearchList[], any>({
        path: `/KPI/years`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TEAMS
     * @name TeamsMonthlyKpiTeamsGet
     * @summary Teams Monthly
     * @request GET:/KPI/teams
     */
    teamsMonthlyKpiTeamsGet: (
      query?: {
        /** Month */
        month?: string
        /** Year */
        year?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KPITeams[], HTTPValidationError>({
        path: `/KPI/teams`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PERSPECTIVE_ME
     * @name KpiUserPerspectiveKpiPerspectiveMeGet
     * @summary Kpi User Perspective
     * @request GET:/KPI/perspective/me
     */
    kpiUserPerspectiveKpiPerspectiveMeGet: (
      query?: {
        /** Year */
        year?: string
        /** Month */
        month?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KPIPerspective[], HTTPValidationError>({
        path: `/KPI/perspective/me`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TOPS_INDICES_ME
     * @name TopsKpiUserIndicesKpiTopsIndicesMeGet
     * @summary Tops Kpi User Indices
     * @request GET:/KPI/tops/indices/me
     */
    topsKpiUserIndicesKpiTopsIndicesMeGet: (
      query?: {
        /** Month */
        month?: string
        /** Year */
        year?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KPITopsIndices[], HTTPValidationError>({
        path: `/KPI/tops/indices/me`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MONTHLY_ME
     * @name KpibscUserKpiMonthlyMeGet
     * @summary Kpibsc User
     * @request GET:/KPI/monthly/me
     */
    kpibscUserKpiMonthlyMeGet: (
      query?: {
        /** Year */
        year?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KPIMonthlyChart[], HTTPValidationError>({
        path: `/KPI/monthly/me`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name KpiTopsKpiTopsGet
     * @summary Kpi Tops
     * @request GET:/KPI/tops
     */
    kpiTopsKpiTopsGet: (
      query?: {
        /**
         * Team Id
         * @default []
         */
        team_Id?: string[]
        /**
         * Position Id
         * @default []
         */
        position_Id?: string[]
        /** Month */
        month?: any
        /** Year */
        year?: any
        /** Name */
        name?: string
        /**
         * N
         * @default 6
         */
        n?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<KPITopsModel[], HTTPValidationError>({
        path: `/KPI/tops`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags INDEX_MONTHLY
     * @name IndexMonthlyKpiIndexMonthlyIndexCodeGet
     * @summary Index Monthly
     * @request GET:/KPI/index-monthly/{index_code}
     */
    indexMonthlyKpiIndexMonthlyIndexCodeGet: (
      indexCode: string,
      query?: {
        /** Year */
        year?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KPIIndexMonthly[], HTTPValidationError>({
        path: `/KPI/index-monthly/${indexCode}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags INDEX_DETAILS
     * @name KpiUserIndexMonthlyKpiIndexDetailsIndexCodeGet
     * @summary Kpi User Index Monthly
     * @request GET:/KPI/index-details/{index_code}
     */
    kpiUserIndexMonthlyKpiIndexDetailsIndexCodeGet: (
      indexCode: string,
      query?: {
        /** Year */
        year?: string
        /** Month */
        month?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KPIIndexDetails[], HTTPValidationError>({
        path: `/KPI/index-details/${indexCode}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ME
     * @name KpibscViewKpiMeGet
     * @summary Kpibsc View
     * @request GET:/KPI/me
     */
    kpibscViewKpiMeGet: (
      query?: {
        /** Year */
        year?: string
        /** Month */
        month?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KPIUser[], HTTPValidationError>({
        path: `/KPI/me`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TEAM_PROGRESS
     * @name TeamProgressKpiTeamProgressGet
     * @summary Team Progress
     * @request GET:/KPI/team-progress
     */
    teamProgressKpiTeamProgressGet: (
      query?: {
        /** Month */
        month?: string
        /** Year */
        year?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KPITeamProgress, HTTPValidationError>({
        path: `/KPI/team-progress`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags USER_REVIEW
     * @name UserReviewKpiUserReviewUserIdGet
     * @summary User Review
     * @request GET:/KPI/user-review/{user_Id}
     */
    userReviewKpiUserReviewUserIdGet: (
      userId: string,
      query?: {
        /** Month */
        month?: string
        /** Year */
        year?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<KPIUserReview, HTTPValidationError>({
        path: `/KPI/user-review/${userId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  clv = {
    /**
     * No description
     *
     * @name CustomerNamesClvCustomersGet
     * @summary Customer Names
     * @request GET:/CLV/customers
     */
    customerNamesClvCustomersGet: (
      query?: {
        /**
         * Name
         * @default ""
         */
        name?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<CLVCustomers[], HTTPValidationError>({
        path: `/CLV/customers`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ClvClvGet
     * @summary Clv
     * @request GET:/CLV/
     */
    clvClvGet: (
      query: {
        /** Start Date */
        start_date: string
        /** End Date */
        end_date: string
        /** An enumeration. */
        sort?: CLVSortEnum
        /**
         * Job Category
         * @default []
         */
        job_category?: string[]
        /** Customer Name */
        customer_name?: string
        /** Just Show Vip */
        just_show_vip?: boolean
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Product Category
         * @default []
         */
        product_category?: string[]
        /**
         * Product Type
         * @default []
         */
        product_type?: string[]
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number
        /**
         * Size
         * @min 1
         * @max 100
         * @default 50
         */
        size?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<PageCLVList, HTTPValidationError>({
        path: `/CLV/`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name FullClvClvFullGet
     * @summary Full Clv
     * @request GET:/CLV/full
     */
    fullClvClvFullGet: (
      query: {
        /** Start Date */
        start_date: any
        /** End Date */
        end_date: any
      },
      params: RequestParams = {}
    ) =>
      this.request<CLVList[], HTTPValidationError>({
        path: `/CLV/full`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name JobCategoriesClvJobCategoriesGet
     * @summary Job Categories
     * @request GET:/CLV/job-categories
     */
    jobCategoriesClvJobCategoriesGet: (
      query?: {
        /** Name */
        name?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<CLVJobCategories[], HTTPValidationError>({
        path: `/CLV/job-categories`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductTypeFilterClvProductTypeGet
     * @summary Producttypefilter
     * @request GET:/CLV/product_type
     */
    productTypeFilterClvProductTypeGet: (
      query?: {
        /**
         * Start Date
         * @format date
         * @default "2000-01-01"
         */
        start_date?: string
        /**
         * End Date
         * @format date
         * @default "2022-10-31T08:37:41.282406"
         */
        end_date?: string
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /** Search */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchList[], HTTPValidationError>({
        path: `/CLV/product_type`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductCategoryFilterClvProductCategoryGet
     * @summary Productcategoryfilter
     * @request GET:/CLV/product_category
     */
    productCategoryFilterClvProductCategoryGet: (
      query?: {
        /**
         * Start Date
         * @format date
         * @default "2000-01-01"
         */
        start_date?: string
        /**
         * End Date
         * @format date
         * @default "2022-10-31T08:37:41.285599"
         */
        end_date?: string
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /** Search */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchList[], HTTPValidationError>({
        path: `/CLV/product_category`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  funnel = {
    /**
     * No description
     *
     * @name FunnelFunnelGet
     * @summary Funnel
     * @request GET:/Funnel/
     */
    funnelFunnelGet: (
      query: {
        /** Start Date */
        start_date: any
        /** End Date */
        end_date: any
        /** Team Id */
        team_Id: any
        /** P Type */
        p_type: any
      },
      params: RequestParams = {}
    ) =>
      this.request<FunnelList[], HTTPValidationError>({
        path: `/Funnel/`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  schedule = {
    /**
     * No description
     *
     * @name RunPythonScheduleScheduleEtlRefreshGet
     * @summary Run Python Schedule
     * @request GET:/schedule/etl-refresh
     */
    runPythonScheduleScheduleEtlRefreshGet: (params: RequestParams = {}) =>
      this.request<EtlRefresh, any>({
        path: `/schedule/etl-refresh`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  users = {
    /**
     * No description
     *
     * @tags ADMIN
     * @name AdminUsersAboutMeGet
     * @summary Admin
     * @request GET:/users/about-me
     */
    adminUsersAboutMeGet: (params: RequestParams = {}) =>
      this.request<AboutMe, any>({
        path: `/users/about-me`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  dates = {
    /**
     * No description
     *
     * @name GetMonthesDatesMonthsGet
     * @summary Get Monthes
     * @request GET:/dates/months
     */
    getMonthesDatesMonthsGet: (params: RequestParams = {}) =>
      this.request<SearchList[], any>({
        path: `/dates/months`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetYearsDatesYearsGet
     * @summary Get Years
     * @request GET:/dates/years
     */
    getYearsDatesYearsGet: (params: RequestParams = {}) =>
      this.request<SearchList[], any>({
        path: `/dates/years`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  productTypes = {
    /**
     * No description
     *
     * @name ProductTypesProductTypesGet
     * @summary Product Types
     * @request GET:/product-types/
     */
    productTypesProductTypesGet: (params: RequestParams = {}) =>
      this.request<ProductTypes[], any>({
        path: `/product-types/`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  priceAssistant = {
    /**
     * No description
     *
     * @name ProductPriceTop2PriceAssistantGet
     * @summary Product Price Top2
     * @request GET:/price_assistant/
     */
    productPriceTop2PriceAssistantGet: (
      query?: {
        /** Product Id */
        product_id?: string[]
        /** Product Category Id */
        product_category_id?: any
      },
      params: RequestParams = {}
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/price_assistant/`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductPriceTop2PriceAssistantUpdateAllGet
     * @summary Product Price Top2
     * @request GET:/price_assistant/update_all
     */
    productPriceTop2PriceAssistantUpdateAllGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/price_assistant/update_all`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductPriceTop2PriceAssistantUpdateGet
     * @summary Product Price Top2
     * @request GET:/price_assistant/update
     */
    productPriceTop2PriceAssistantUpdateGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/price_assistant/update`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductPriceTop2PriceAssistantUpdate2Get
     * @summary Product Price Top2
     * @request GET:/price_assistant/update2
     */
    productPriceTop2PriceAssistantUpdate2Get: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/price_assistant/update2`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name PriceSuggestionPriceAssistantPriceSuggestionGet
     * @summary Price Suggestion
     * @request GET:/price_assistant/price_suggestion
     */
    priceSuggestionPriceAssistantPriceSuggestionGet: (
      query?: {
        /**
         * Products
         * @default []
         */
        products?: string[]
        /**
         * Categories
         * @default []
         */
        categories?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/price_assistant/price_suggestion`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  inventory = {
    /**
     * No description
     *
     * @name UnpaidInventoryInventoryGet
     * @summary Unpaid Inventory
     * @request GET:/inventory/
     */
    unpaidInventoryInventoryGet: (
      query?: {
        /** Page */
        page?: number
        /** Page Size */
        page_size?: number
        /** An enumeration. */
        sort?: InventorySortEnum
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Month
         * @default []
         */
        month?: string[]
        /**
         * Season
         * @default []
         */
        season?: string[]
        /**
         * Year
         * @default []
         */
        year?: string[]
        /**
         * Start Inventory
         * @default -100000000000
         */
        start_inventory?: any
        /**
         * End Inventory
         * @default 100000000000
         */
        end_inventory?: any
        /**
         * Product Numbers
         * @default []
         */
        product_numbers?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<PageInventory, HTTPValidationError>({
        path: `/inventory/`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name UnpaidInventoryInWareInventoryInwareGet
     * @summary Unpaid Inventory In Ware
     * @request GET:/inventory/inware
     */
    unpaidInventoryInWareInventoryInwareGet: (
      query?: {
        /** Page */
        page?: number
        /** Page Size */
        page_size?: number
        /** An enumeration. */
        sort?: InwareSortEnum
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: string
        /**
         * End Date
         * @format date
         * @default "2022-10-31"
         */
        end_date?: string
        /**
         * Month
         * @default []
         */
        month?: string[]
        /**
         * Season
         * @default []
         */
        season?: string[]
        /**
         * Year
         * @default []
         */
        year?: string[]
        /**
         * Start Inventory
         * @default -100000000000
         */
        start_inventory?: number
        /**
         * End Inventory
         * @default 100000000000
         */
        end_inventory?: number
        /**
         * Product Numbers
         * @default []
         */
        product_numbers?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<PageInventoryInware, HTTPValidationError>({
        path: `/inventory/inware`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name UnpaidInventoryOutWareInventoryOutwareGet
     * @summary Unpaid Inventory Out Ware
     * @request GET:/inventory/outware
     */
    unpaidInventoryOutWareInventoryOutwareGet: (
      query?: {
        /** Page */
        page?: number
        /** Page Size */
        page_size?: number
        /** An enumeration. */
        sort?: OutwareSortEnum
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: string
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: string
        /**
         * Month
         * @default []
         */
        month?: string[]
        /**
         * Season
         * @default []
         */
        season?: string[]
        /**
         * Year
         * @default []
         */
        year?: string[]
        /**
         * Start Inventory
         * @default -100000000000
         */
        start_inventory?: number
        /**
         * End Inventory
         * @default 100000000000
         */
        end_inventory?: number
        /**
         * Product Numbers
         * @default []
         */
        product_numbers?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<PageInventoryOutware, HTTPValidationError>({
        path: `/inventory/outware`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  productsList = {
    /**
     * No description
     *
     * @name ProductsProductsListGet
     * @summary Products
     * @request GET:/products_list/
     */
    productsProductsListGet: (
      query?: {
        /** Product Number */
        product_number?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<Product[], HTTPValidationError>({
        path: `/products_list/`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  product = {
    /**
     * No description
     *
     * @name GetYearsProductYearsGet
     * @summary Get Years
     * @request GET:/product/years
     */
    getYearsProductYearsGet: (
      query: {
        /** Start Date */
        start_date: string
        /** End Date */
        end_date: string
        /** Search */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchList[], HTTPValidationError>({
        path: `/product/years`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetYearsProductMonthsGet
     * @summary Get Years
     * @request GET:/product/months
     */
    getYearsProductMonthsGet: (
      query: {
        /** Start Date */
        start_date: string
        /** End Date */
        end_date: string
        /** Search */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchList[], HTTPValidationError>({
        path: `/product/months`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetBrandsProductBrandsGet
     * @summary Get Brands
     * @request GET:/product/brands
     */
    getBrandsProductBrandsGet: (
      query?: {
        /** Name */
        name?: string
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Team
         * @default []
         */
        team?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchList[], HTTPValidationError>({
        path: `/product/brands`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetBrandsProductTeamsGet
     * @summary Get Brands
     * @request GET:/product/teams
     */
    getBrandsProductTeamsGet: (
      query?: {
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Year
         * @default []
         */
        year?: number[]
        /** Name */
        name?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchList[], HTTPValidationError>({
        path: `/product/teams`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductProductProductTypeGet
     * @summary Product
     * @request GET:/product/product_type
     */
    productProductProductTypeGet: (
      query?: {
        /** Search */
        search?: string
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /** An enumeration. */
        sort?: ProductTypeSortEnum
        /** Product Type */
        product_type?: string
        /**
         * Team
         * @default []
         */
        team?: string[]
        /**
         * Brand
         * @default []
         */
        brand?: string[]
        /**
         * Model
         * @default []
         */
        model?: string[]
        /** Product Category Id */
        product_category_Id?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ProductType[], HTTPValidationError>({
        path: `/product/product_type`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductProductProductCategoryGet
     * @summary Product
     * @request GET:/product/product_category
     */
    productProductProductCategoryGet: (
      query?: {
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /** Search */
        search?: string
        /** An enumeration. */
        sort?: ProductCategorySortEnum
        /** Product Category */
        product_category?: string
        /**
         * Product Typeid
         * @default []
         */
        product_typeId?: string[]
        /**
         * Team
         * @default []
         */
        team?: string[]
        /**
         * Brand
         * @default []
         */
        brand?: string[]
        /**
         * Model
         * @default []
         */
        model?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ProductCategory[], HTTPValidationError>({
        path: `/product/product_category`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductProductProductDetailsProductTypeIdGet
     * @summary Product
     * @request GET:/product/product_details/{product_type_Id}
     */
    productProductProductDetailsProductTypeIdGet: (
      productTypeId: string,
      query?: {
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Product Name
         * @default []
         */
        product_name?: string[]
        /**
         * Team
         * @default []
         */
        team?: string[]
        /**
         * Brand
         * @default []
         */
        brand?: string[]
        /** An enumeration. */
        sort?: ProductDetailsSortEnum
        /**
         * Model
         * @default []
         */
        model?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ProductTypeDetails[], HTTPValidationError>({
        path: `/product/product_details/${productTypeId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductProductProductTypePieChartGet
     * @summary Product
     * @request GET:/product/product_type_pie_chart
     */
    productProductProductTypePieChartGet: (
      query?: {
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Month
         * @default []
         */
        month?: string[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /** Product Category Id */
        product_category_Id?: string
        /**
         * Team
         * @default []
         */
        team?: string[]
        /**
         * Brand
         * @default []
         */
        brand?: string[]
        /**
         * Model
         * @default []
         */
        model?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ProductTypePieChart[], HTTPValidationError>({
        path: `/product/product_type_pie_chart`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductProductProductCategoryPieChartGet
     * @summary Product
     * @request GET:/product/product_category_pie_chart
     */
    productProductProductCategoryPieChartGet: (
      query?: {
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Month
         * @default []
         */
        month?: string[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Product Category
         * @default []
         */
        product_category?: string[]
        /**
         * Team
         * @default []
         */
        team?: string[]
        /**
         * Brand
         * @default []
         */
        brand?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ProductCategoryPieChart[], HTTPValidationError>({
        path: `/product/product_category_pie_chart`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductTypeFilterProductProductTypeFilterGet
     * @summary Product Type Filter
     * @request GET:/product/product_type_filter
     */
    productTypeFilterProductProductTypeFilterGet: (
      query?: {
        /** Search */
        search?: string
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Team
         * @default []
         */
        team?: string[]
        /**
         * Brand
         * @default []
         */
        brand?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchList[], HTTPValidationError>({
        path: `/product/product_type_filter`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  grade = {
    /**
     * No description
     *
     * @name GradeRouterGradeGet
     * @summary Grade Router
     * @request GET:/grade/
     */
    gradeRouterGradeGet: (
      query?: {
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Supplier Id
         * @default []
         */
        supplier_Id?: string[]
        /**
         * Team Id
         * @default []
         */
        team_Id?: string[]
        /**
         * Product Type Id
         * @default []
         */
        product_type_Id?: string[]
        /**
         * Max Purchase Count
         * @default 1000000
         */
        max_purchase_count?: number
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Has No Purchase
         * @default false
         */
        has_no_purchase?: boolean
        /**
         * Has No Sub
         * @default false
         */
        has_no_sub?: boolean
        /**
         * Is Mediator
         * @default false
         */
        is_mediator?: boolean
        /**
         * More Than Three Month
         * @default false
         */
        more_than_three_month?: boolean
        /**
         * N
         * @default "0"
         */
        n?: string
        /**
         * W Rank Amount
         * @default 1
         */
        W_Rank_Amount?: number
        /**
         * W Rank Count
         * @default 1
         */
        W_Rank_Count?: number
        /**
         * W Rank Profit
         * @default 1
         */
        W_Rank_Profit?: number
        /**
         * W Rank Quantity
         * @default 1
         */
        W_Rank_Quantity?: number
        /**
         * Brand
         * @default []
         */
        brand?: string[]
        /**
         * Product Size
         * @default []
         */
        product_size?: string[]
        /** Name */
        name?: string
        /** An enumeration. */
        sort?: GradeSortEnum
        /** @default "none" */
        finantial_status?: FinantialStatusEnum
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number
        /**
         * Size
         * @min 1
         * @max 100
         * @default 50
         */
        size?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<PageGradeResModel, HTTPValidationError>({
        path: `/grade/`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name SuppliersDetailsGradeSupplierProductSupplierIdGet
     * @summary Suppliers Details
     * @request GET:/grade/supplier_product/{supplier_Id}
     */
    suppliersDetailsGradeSupplierProductSupplierIdGet: (
      supplierId: string,
      query?: {
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Team Id
         * @default []
         */
        team_Id?: string[]
        /**
         * Product Type Id
         * @default []
         */
        product_type_Id?: string[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Has No Purchase
         * @default false
         */
        has_no_purchase?: boolean
        /**
         * Has No Sub
         * @default false
         */
        has_no_sub?: boolean
        /**
         * Less Than Ten
         * @default false
         */
        less_than_ten?: boolean
        /**
         * Is Mediator
         * @default false
         */
        is_mediator?: boolean
        /**
         * More Than Three Month
         * @default false
         */
        more_than_three_month?: boolean
        /**
         * Brand
         * @default []
         */
        brand?: string[]
        /**
         * Product Size
         * @default []
         */
        product_size?: string[]
        /** An enumeration. */
        sort?: SupplierProductSortEnum
      },
      params: RequestParams = {}
    ) =>
      this.request<GradeSupplierProduct[], HTTPValidationError>({
        path: `/grade/supplier_product/${supplierId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name SuppliersViewGradeSuppliersGet
     * @summary Suppliers View
     * @request GET:/grade/suppliers
     */
    suppliersViewGradeSuppliersGet: (
      query?: {
        /** Supplier Name */
        supplier_name?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SuppResModel[], HTTPValidationError>({
        path: `/grade/suppliers`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TypeViewGradeProductTypeGet
     * @summary Type View
     * @request GET:/grade/product_type
     */
    typeViewGradeProductTypeGet: (
      query?: {
        /** Product Type Name */
        product_type_name?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<ProductTypeResModel[], HTTPValidationError>({
        path: `/grade/product_type`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name MonthsGradeMonthsGet
     * @summary Months
     * @request GET:/grade/months
     */
    monthsGradeMonthsGet: (params: RequestParams = {}) =>
      this.request<GradeMonths[], any>({
        path: `/grade/months`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name YearsGradeYearsGet
     * @summary Years
     * @request GET:/grade/years
     */
    yearsGradeYearsGet: (params: RequestParams = {}) =>
      this.request<GradeYears[], any>({
        path: `/grade/years`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name SeasonsGradeSeasonsGet
     * @summary Seasons
     * @request GET:/grade/seasons
     */
    seasonsGradeSeasonsGet: (params: RequestParams = {}) =>
      this.request<GradeMonths[], any>({
        path: `/grade/seasons`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TimeViewGradeTimeGet
     * @summary Time View
     * @request GET:/grade/time
     */
    timeViewGradeTimeGet: (
      query?: {
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Month
         * @default []
         */
        month?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<TimesResModel[], HTTPValidationError>({
        path: `/grade/time`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TeamViewGradeTeamsGet
     * @summary Team View
     * @request GET:/grade/teams
     */
    teamViewGradeTeamsGet: (
      query?: {
        /** Name */
        name?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<TeamResModel[], HTTPValidationError>({
        path: `/grade/teams`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name BrandViewGradeBrandsGet
     * @summary Brand View
     * @request GET:/grade/brands
     */
    brandViewGradeBrandsGet: (
      query?: {
        /** Name */
        name?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchList[], HTTPValidationError>({
        path: `/grade/brands`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductSizeGradeSizeGet
     * @summary Product Size
     * @request GET:/grade/size
     */
    productSizeGradeSizeGet: (
      query?: {
        /** Name */
        name?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchList[], HTTPValidationError>({
        path: `/grade/size`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  teamsDashboard = {
    /**
     * No description
     *
     * @name TeamsViewsMainTeamsDashboardMainTableGet
     * @summary Teams Views Main
     * @request GET:/teams_dashboard/main_table
     */
    teamsViewsMainTeamsDashboardMainTableGet: (
      query?: {
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /** An enumeration. */
        sort?: TeamDashboardSortEnum
        /**
         * Team Id
         * @default []
         */
        team_id?: string[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Settlement Type
         * @default []
         */
        settlement_type?: number[]
        /**
         * Status Code
         * @default []
         */
        status_code?: number[]
        /** Team Name */
        team_name?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AppModelsTeamsDashboardMainTableModelMainTableModel[], HTTPValidationError>({
        path: `/teams_dashboard/main_table`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TeamsViewsPiechartTeamsDashboardPiechartGet
     * @summary Teams Views Piechart
     * @request GET:/teams_dashboard/piechart
     */
    teamsViewsPiechartTeamsDashboardPiechartGet: (
      query?: {
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Settlement Type
         * @default []
         */
        settlement_type?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Status Code
         * @default []
         */
        status_code?: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<PiechartModel[], HTTPValidationError>({
        path: `/teams_dashboard/piechart`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TeamsViewsSettleFilterTeamsDashboardSettlementTypeFilterGet
     * @summary Teams Views Settle Filter
     * @request GET:/teams_dashboard/settlement_type_filter
     */
    teamsViewsSettleFilterTeamsDashboardSettlementTypeFilterGet: (
      query?: {
        /** Search */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchList[], HTTPValidationError>({
        path: `/teams_dashboard/settlement_type_filter`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TeamsViewsStatusFilterTeamsDashboardStatuscodeFilterGet
     * @summary Teams Views Status Filter
     * @request GET:/teams_dashboard/statuscode_filter
     */
    teamsViewsStatusFilterTeamsDashboardStatuscodeFilterGet: (
      query?: {
        /** Search */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchList[], HTTPValidationError>({
        path: `/teams_dashboard/statuscode_filter`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TeamsViewsProcedureTeamsDashboardProcedureChartGet
     * @summary Teams Views Procedure
     * @request GET:/teams_dashboard/procedure_chart
     */
    teamsViewsProcedureTeamsDashboardProcedureChartGet: (
      query?: {
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Team Id
         * @default []
         */
        team_id?: string[]
        /**
         * Settlement Type
         * @default []
         */
        settlement_type?: number[]
        /**
         * Status Code
         * @default []
         */
        status_code?: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ProcedureChartModel[], HTTPValidationError>({
        path: `/teams_dashboard/procedure_chart`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TeamsViewsModalTeamsDashboardModalGet
     * @summary Teams Views Modal
     * @request GET:/teams_dashboard/modal
     */
    teamsViewsModalTeamsDashboardModalGet: (
      query: {
        /** Team Id */
        team_id: string
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Settlement Type
         * @default []
         */
        settlement_type?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Status Code
         * @default []
         */
        status_code?: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<ModalModel[], HTTPValidationError>({
        path: `/teams_dashboard/modal`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TeamsViewsMembersTeamsDashboardSalesMemberGet
     * @summary Teams Views Members
     * @request GET:/teams_dashboard/sales_member
     */
    teamsViewsMembersTeamsDashboardSalesMemberGet: (
      query: {
        /** Team Id */
        team_id: string
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /** An enumeration. */
        sort?: SalesMemberSortEnum
        /**
         * Settlement Type
         * @default []
         */
        settlement_type?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Status Code
         * @default []
         */
        status_code?: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<SalesPursonModel[], HTTPValidationError>({
        path: `/teams_dashboard/sales_member`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TeamsViewsMembersTeamsDashboardPurchaseMemberGet
     * @summary Teams Views Members
     * @request GET:/teams_dashboard/purchase_member
     */
    teamsViewsMembersTeamsDashboardPurchaseMemberGet: (
      query: {
        /** Team Id */
        team_id: string
        /**
         * Start Date
         * @default "2000-01-01"
         */
        start_date?: any
        /**
         * End Date
         * @default "2022-10-31"
         */
        end_date?: any
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /** An enumeration. */
        sort?: PurchaseMemberSortEnum
        /**
         * Settlement Type
         * @default []
         */
        settlement_type?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Status Code
         * @default []
         */
        status_code?: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<PurchasePursonModel[], HTTPValidationError>({
        path: `/teams_dashboard/purchase_member`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  marketing = {
    /**
     * No description
     *
     * @name MarketingMarketingGet
     * @summary Marketing
     * @request GET:/marketing/
     */
    marketingMarketingGet: (
      query?: {
        /**
         * Fiscal Year
         * @default ["01"]
         */
        fiscal_year?: string[]
        /** An enumeration. */
        sort?: MarketingBudgetSortEnum
        /**
         * Detail Account Id
         * @default []
         */
        detail_account_Id?: string[]
        /** Search */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<AppModelsMarketingBudjetMarketingMainTableModel[], HTTPValidationError>({
        path: `/marketing/`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name MarketingDebtorMarketingDebtorGet
     * @summary Marketing Debtor
     * @request GET:/marketing/debtor
     */
    marketingDebtorMarketingDebtorGet: (
      query: {
        /** Detail Account Id */
        detail_account_Id: string
        /**
         * Fiscal Year
         * @default ["01"]
         */
        fiscal_year?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<DebtorResModel[], HTTPValidationError>({
        path: `/marketing/debtor`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name MarketingCreditorMarketingCreditorGet
     * @summary Marketing Creditor
     * @request GET:/marketing/creditor
     */
    marketingCreditorMarketingCreditorGet: (
      query: {
        /** Detail Account Id */
        detail_account_Id: string
        /**
         * Fiscal Year
         * @default ["01"]
         */
        fiscal_year?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<CreditorResModel[], HTTPValidationError>({
        path: `/marketing/creditor`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name FiscalYearsMarketingFiscalYearGet
     * @summary Fiscal Years
     * @request GET:/marketing/fiscal_year
     */
    fiscalYearsMarketingFiscalYearGet: (
      query?: {
        /** Name */
        name?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<FiscalYearResModel[], HTTPValidationError>({
        path: `/marketing/fiscal_year`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name DetailAccountNameMarketingDetailAccountGet
     * @summary Detail Account Name
     * @request GET:/marketing/detail_account
     */
    detailAccountNameMarketingDetailAccountGet: (
      query?: {
        /** Account Name */
        account_name?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<DetailAccountResModel[], HTTPValidationError>({
        path: `/marketing/detail_account`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name RemainBudjetMarketingRemainBudjetGet
     * @summary Remain Budjet
     * @request GET:/marketing/remain_budjet
     */
    remainBudjetMarketingRemainBudjetGet: (
      query?: {
        /**
         * Fiscal Year
         * @default ["01"]
         */
        fiscal_year?: string[]
        /** Search */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<RemainBudjetResModel[], HTTPValidationError>({
        path: `/marketing/remain_budjet`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  customers = {
    /**
     * No description
     *
     * @name CustomersAnalysisCustomersMainTableGet
     * @summary Customersanalysis
     * @request GET:/customers/main_table
     */
    customersAnalysisCustomersMainTableGet: (
      query?: {
        /**
         * Start Date
         * @format date
         * @default "2000-01-01"
         */
        start_date?: string
        /**
         * End Date
         * @format date
         * @default "2022-10-31T08:37:43.545123"
         */
        end_date?: string
        /** An enumeration. */
        sort?: CustomerSortEnum
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Team Id
         * @default []
         */
        team_id?: string[]
        /**
         * Last Invoice Start
         * @format date
         * @default "2000-01-01"
         */
        last_invoice_start?: string
        /**
         * Last Invoice End
         * @format date
         * @default "2022-10-31T08:37:43.545189"
         */
        last_invoice_end?: string
        /**
         * Product Type
         * @default []
         */
        product_type?: string[]
        /**
         * Subsidiary Id
         * @default []
         */
        subsidiary_id?: string[]
        /**
         * Start Amount
         * @default -1e+22
         */
        start_amount?: number
        /**
         * End Amount
         * @default 1e+22
         */
        end_amount?: number
        /**
         * Start Profit
         * @default -1e+22
         */
        start_profit?: number
        /**
         * End Profit
         * @default 1e+22
         */
        end_profit?: number
        /**
         * Start Quantity
         * @default -1e+22
         */
        start_quantity?: number
        /**
         * End Quantity
         * @default 1e+22
         */
        end_quantity?: number
        /** Max Invoice */
        max_invoice?: string
        /** Customer Name */
        customer_name?: string
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number
        /**
         * Size
         * @min 1
         * @max 100
         * @default 50
         */
        size?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<PageMainTableResponse, HTTPValidationError>({
        path: `/customers/main_table`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name CustomersDetailsCustomersCustomersDetailsSubsidiaryIdGet
     * @summary Customersdetails
     * @request GET:/customers/customers_details/{subsidiary_id}
     */
    customersDetailsCustomersCustomersDetailsSubsidiaryIdGet: (
      subsidiaryId: string,
      query?: {
        /**
         * Start Date
         * @format date
         * @default "2000-01-01"
         */
        start_date?: string
        /**
         * End Date
         * @format date
         * @default "2022-10-31T08:37:43.560375"
         */
        end_date?: string
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Team Id
         * @default []
         */
        team_id?: string[]
        /** An enumeration. */
        sort?: CustomerDetailsSortEnum
      },
      params: RequestParams = {}
    ) =>
      this.request<CustomerDetails[], HTTPValidationError>({
        path: `/customers/customers_details/${subsidiaryId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TeamsFilterCustomersTeamsFilterGet
     * @summary Teamsfilter
     * @request GET:/customers/teams_filter
     */
    teamsFilterCustomersTeamsFilterGet: (
      query?: {
        /**
         * Start Date
         * @format date
         * @default "2000-01-01"
         */
        start_date?: string
        /**
         * End Date
         * @format date
         * @default "2022-10-31T08:37:43.568230"
         */
        end_date?: string
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Subsidiary Id
         * @default []
         */
        subsidiary_id?: string[]
        /** Search */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchList[], HTTPValidationError>({
        path: `/customers/teams_filter`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProductTypeFilterCustomersProductTypeFilterGet
     * @summary Producttypefilter
     * @request GET:/customers/product_type_filter
     */
    productTypeFilterCustomersProductTypeFilterGet: (
      query?: {
        /**
         * Start Date
         * @format date
         * @default "2000-01-01"
         */
        start_date?: string
        /**
         * End Date
         * @format date
         * @default "2022-10-31T08:37:43.571355"
         */
        end_date?: string
        /**
         * Month
         * @default []
         */
        month?: number[]
        /**
         * Year
         * @default []
         */
        year?: number[]
        /**
         * Season
         * @default []
         */
        season?: number[]
        /**
         * Team Id
         * @default []
         */
        team_id?: string[]
        /** Search */
        search?: string
        /**
         * Subsidiary Id
         * @default []
         */
        subsidiary_id?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchList[], HTTPValidationError>({
        path: `/customers/product_type_filter`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  transportation = {
    /**
     * No description
     *
     * @name TempTransportationGet
     * @summary Temp
     * @request GET:/transportation/
     */
    tempTransportationGet: (
      query?: {
        /** Distance */
        distance?: number
        /** Quantity Kg */
        quantity_kg?: number
        /**
         * Auto Type
         * @default []
         */
        auto_type?: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/transportation/`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TempTransportationSelectOriginGet
     * @summary Temp
     * @request GET:/transportation/select_origin
     */
    tempTransportationSelectOriginGet: (
      query?: {
        /** Destination */
        destination?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/transportation/select_origin`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TempTransportationSelectDestinationGet
     * @summary Temp
     * @request GET:/transportation/select_destination
     */
    tempTransportationSelectDestinationGet: (
      query?: {
        /** Origin */
        origin?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/transportation/select_destination`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TempTransportationSelectAutoTypeGet
     * @summary Temp
     * @request GET:/transportation/select_auto_type
     */
    tempTransportationSelectAutoTypeGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/transportation/select_auto_type`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TempTransportationCityDistanceGet
     * @summary Temp
     * @request GET:/transportation/city_distance
     */
    tempTransportationCityDistanceGet: (
      query?: {
        /** Origin */
        origin?: string
        /** Destination */
        destination?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/transportation/city_distance`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name TempTransportationSelectProductCategoryGet
     * @summary Temp
     * @request GET:/transportation/select_product_category
     */
    tempTransportationSelectProductCategoryGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/transportation/select_product_category`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
}
